import { render, staticRenderFns } from "./mainPage-entrance.vue?vue&type=template&id=77fe3cf4&scoped=true"
import script from "./mainPage-entrance.vue?vue&type=script&lang=js"
export * from "./mainPage-entrance.vue?vue&type=script&lang=js"
import style0 from "./mainPage-entrance.vue?vue&type=style&index=0&id=77fe3cf4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77fe3cf4",
  null
  
)

export default component.exports